// Usage metering. No-op until Phase 5 wires the endpoint; kept as a stable seam so
// the element can call postEvent() from day one without behavior changes.

export interface StationEvent {
  apiKey?: string;
  assemblyId: string;
  station: string;
  ts: number;
}

let endpoint: string | null = null;

/** Phase 5: set to `${assetBase}events` (or the API origin) to enable metering. */
export function configureEvents(url: string | null): void {
  endpoint = url;
}

export function postEvent(evt: StationEvent): void {
  if (!endpoint) return; // disabled in the demo build
  try {
    const body = JSON.stringify(evt);
    // sendBeacon survives navigation and never blocks the render path.
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(endpoint, body);
    } else {
      void fetch(endpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body,
        keepalive: true,
      });
    }
  } catch {
    // metering must never break the viewer
  }
}
